import { Injectable } from '@angular/core';

@Injectable()
export class FlashService
{
    public hasFlash(flashType:string):boolean
    {
       return (localStorage.getItem('flash.'+flashType)!==null
          && localStorage.getItem('flash.'+flashType).length > 0)
    }
  
    public getFlash(flashType:string):string
    {
       var flash:string = localStorage.getItem('flash.'+flashType);

       window.setTimeout(()=>
       {
        localStorage.removeItem('flash.'+flashType);
       },5000);

       return flash;
    }

    public setFlash(flashType:string, message:string)
    {
        localStorage.setItem('flash.'+flashType,message);
    }    
}


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/services/flash.service.ts